var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloMutation',{attrs:{"mutation":function (gql) { return _vm.updateChapterNameQuery; },"variables":{
    chapterId: _vm.iri,
    name: _vm.mutableName,
  }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var mutate = ref.mutate;
  var loading = ref.loading;
return [_c('v-text-field',{attrs:{"hide-details":"","outlined":"","background-color":"white","loading":loading ? 'primaryAction' : false,"placeholder":_vm.$t('chapter.chapterTitle'),"dense":""},on:{"keydown":function($event){return _vm.debouncedTextInput(mutate)}},model:{value:(_vm.mutableName),callback:function ($$v) {_vm.mutableName=$$v},expression:"mutableName"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }